// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-js": require("gatsby-module-loader?name=component---src-templates-page-js!/home/vsts/work/1/s/src/templates/page.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/home/vsts/work/1/s/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/home/vsts/work/1/s/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/home/vsts/work/1/s/.cache/json/layout-index.json"),
  "what-we-do.json": require("gatsby-module-loader?name=path---what-we-do!/home/vsts/work/1/s/.cache/json/what-we-do.json"),
  "who-we-are.json": require("gatsby-module-loader?name=path---who-we-are!/home/vsts/work/1/s/.cache/json/who-we-are.json"),
  "what-you-can-do.json": require("gatsby-module-loader?name=path---what-you-can-do!/home/vsts/work/1/s/.cache/json/what-you-can-do.json"),
  "contact-us.json": require("gatsby-module-loader?name=path---contact-us!/home/vsts/work/1/s/.cache/json/contact-us.json"),
  "our-trustees.json": require("gatsby-module-loader?name=path---our-trustees!/home/vsts/work/1/s/.cache/json/our-trustees.json"),
  "our-news.json": require("gatsby-module-loader?name=path---our-news!/home/vsts/work/1/s/.cache/json/our-news.json"),
  "our-story.json": require("gatsby-module-loader?name=path---our-story!/home/vsts/work/1/s/.cache/json/our-story.json"),
  "our-supporters.json": require("gatsby-module-loader?name=path---our-supporters!/home/vsts/work/1/s/.cache/json/our-supporters.json"),
  "blog-post-2.json": require("gatsby-module-loader?name=path---blog-post-2!/home/vsts/work/1/s/.cache/json/blog-post-2.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/home/vsts/work/1/s/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/home/vsts/work/1/s/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/home/vsts/work/1/s/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/home/vsts/work/1/s/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js